import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { LanguageProvider } from "@/i18n/LanguageContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppShell from "@/components/layout/AppShell";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AcceptInvite from "@/pages/AcceptInvite";
import Sensors from "@/pages/Sensors";
import Gyms from "@/pages/Gyms";
import ApiKeys from "@/pages/ApiKeys";
import Invites from "@/pages/Invites";
import Members from "@/pages/Members";
import Clients from "@/pages/Clients";
import Help from "@/pages/Help";
import PublicIntake from "@/pages/PublicIntake";
import TermsAndConditions from "@/pages/TermsAndConditions";
import { Toaster } from "@/components/ui/sonner";

function Protected({ children }) {
  return (
    <ProtectedRoute>
      <AppShell>{children}</AppShell>
    </ProtectedRoute>
  );
}

export default function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/accept-invite" element={<AcceptInvite />} />
            <Route path="/intake/:token" element={<PublicIntake />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />

            <Route path="/" element={<Navigate to="/sensors" replace />} />
            <Route path="/sensors"   element={<Protected><Sensors /></Protected>} />
            <Route path="/gyms"      element={<Protected><Gyms /></Protected>} />
            <Route path="/keys"      element={<Protected><ApiKeys /></Protected>} />
            <Route path="/invites"   element={<Protected><Invites /></Protected>} />
            <Route path="/members"   element={<Protected><Members /></Protected>} />
            <Route path="/clients"   element={<Protected><Clients /></Protected>} />
            <Route path="/help"      element={<Protected><Help /></Protected>} />

            <Route path="*" element={<Navigate to="/sensors" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </LanguageProvider>
  );
}
